<template>
  <div class="hr-input-phone" :class="{ ...state.displayCountriesList }">
    <hr-input
      type="number"
      v-bind="$attrs"
      :value="state.theValue"
      :formatter="state.formatter"
      class="DSInputPhone_DSInput"
      :max="15"
      @update="input"
      @blur="blur"
      @focus="focus"
      :disabled="disabled"
      :masked="masked"
    >
      <template v-slot:prepend>
        <div
          class="DSInputPhone__country form-control"
          :class="{ disabled: disabled, 'fs-mask': masked }"
          @click="toggleCountriesList"
        >
          <span
            v-if="!state.theCountry"
            solid
            class="DSInputPhone__country__no-selected"
            >(+)</span
          >
          <template v-if="state.theCountry">
            {{ state.theCountry.dial_code }}
          </template>
          <co-icon name="arrow-down"></co-icon>
        </div>
      </template>
    </hr-input>

    <hr-input-phone-countries-list
      :countries="state.countries"
      :visible="state.displayCountriesList"
      @update:value="theCountryChange"
      @visible="toggleCountriesList"
    ></hr-input-phone-countries-list>

    <div v-if="$slots.invalid" class="hr-input-phone__invalid">
      <slot name="invalid"></slot>
    </div>
  </div>
</template>

<script>
// This component follow the E.164 pattern to display numbers (https://en.wikipedia.org/wiki/E.164)
import countries from '@/core/country-area-code';
import HrInputPhoneCountriesList from '@/components/hr-input-phone-countries-list';
import HrInput from '@/components/hr-input.vue';
import { CoIcon } from '@deputy/copilot2';
import { reactive } from 'vue';
export default {
  name: 'hr-input-phone',
  components: { HrInputPhoneCountriesList, HrInput, CoIcon },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    masked: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      formatter: (value) => value.replace(/[^\d]/g, '').replace(/^0/, ''),
      countries,
      theValue: null,
      theCountry: null,
      displayCountriesList: false,
    });

    if (props.value) {
      setValue(props.value);
    }
    function emitEvent(evt) {
      emit(evt, {
        country: state.theCountry?.name,
        code: state.theCountry?.dial_code,
        number: state.theValue,
      });
    }
    function blur() {
      emitEvent('blur');
    }
    function focus() {
      emitEvent('focus');
    }
    function input(val) {
      state.theValue = val;
      emitEvent('update');
    }
    function toggleCountriesList(opt) {
      if (props.disabled) {
        return;
      }
      state.displayCountriesList =
        opt !== true || opt !== false ? !state.displayCountriesList : opt;
    }

    function getCountry(code) {
      return state.countries.find((country) => country.dial_code === code);
    }
    function setValue(value) {
      let val = value;

      if (typeof val === 'string' || typeof val === 'number') {
        state.theValue = val;
        return true;
      }

      if (val.code) {
        state.theCountry = getCountry(val.code);
      }

      state.theValue = val.number || '';
      emitEvent('update');
    }

    function theCountryChange(value) {
      state.theCountry = value;
      state.theValue = '';
      emitEvent('update');
    }
    return {
      state,
      blur,
      focus,
      input,
      toggleCountriesList,
      getCountry,
      setValue,
      theCountryChange,
    };
  },
};
</script>

<style scoped>
.hr-input-phone {
  width: 100%;
}

.DSInputPhone__country {
  cursor: pointer;
  flex: 1;
  border-right: 0;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  white-space: nowrap;
}

.DSInputPhone.displayCountriesList .DSInputPhone__country {
  border-bottom-left-radius: 0px;
}
</style>

<style>
/* override DSInput css */
.DSInputPhone.displayCountriesList
  .DSInputPhone_DSInput
  .DSInput__input
  .DSInput__input__input {
  border-bottom-right-radius: 0px;
}

.DSInputPhone_DSInput .DSInput__input .DSInput__input__input {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.DSInputPhone__country.disabled {
  background-color: #eee;
  opacity: 1;
  border: 1px solid var(--co-lines-border-solid);
  color: var(--co-text-secondary);
  cursor: not-allowed;
}

.hr-input-phone__invalid {
  color: var(--co-text-attention);
  margin-top: 5px;
}

@media only screen and (max-width: 768px) {
  .hr-input-phone__invalid {
    font-size: 16px;
  }
}
</style>
